<template>
  <section class="section">
    <div class="container">
      <div class="columns">
        <div class="column is-10">
          <h1 class="title">
            <template v-if="!id">
              {{ $translate('new_patient') | capitalize }}
            </template>
            <template v-else>
              {{ $translate('modify_patient') | capitalize }}
            </template>
          </h1>
        </div>
        <div class="column has-text-right">
          <b-field grouped position="is-right">
            <b-field>
              <b-tooltip v-if="id" :label="$translate('delete') | capitalize" position="is-left" type="is-danger">
                <button class="button is-danger" @click="deleteItem()">
                  <b-icon icon="delete-outline" />
                </button>
              </b-tooltip>
            </b-field>
            <b-field>
              <b-tooltip :label="$translate('save') | capitalize" position="is-left">
                <button class="button is-primary" @click="send(false)">
                  <b-icon icon="content-save-outline" />
                </button>
              </b-tooltip>
            </b-field>
            <b-field>
              <b-tooltip :label="$translate('save_exit') | capitalize" position="is-left">
                <button class="button is-primary" @click="send(true)">
                  <b-icon icon="exit-to-app" />
                </button>
              </b-tooltip>
            </b-field>
          </b-field>
        </div>
      </div>
      <b-field :type="{ 'is-danger': errors.has('company') }" :message="errors.first('company')" horizontal
        :label="$translate('company') | capitalize">
        <b-select v-model="patient.companyId" v-validate="'required'" :placeholder="$translate('placeholder_client')"
          name="company" :disabled="id != undefined && !allCompanies" @input="
            onCompanyChanged()
          patient.shopId = null
          patient.technician = null
            ">
          <option v-for="company in availableCompanies" :key="company.id" :value="company.id">
            {{ company.name }}
          </option>
        </b-select>
      </b-field>
      <b-field :type="{ 'is-danger': errors.has('shop') }" :message="errors.first('shop')" horizontal
        :label="$translate('shop') | capitalize">
        <b-select v-model="patient.shopId" v-validate="'required'" :placeholder="$translate('placeholder_shop')"
          name="shop" @input="
            onShopChanged()
          patient.technician = technicianIsDisabled ? patient.technician : null
            ">
          <option v-for="shop in availableShops" :key="shop.id" :value="shop.id">
            {{ shop.name }}
          </option>
        </b-select>
      </b-field>
      <b-field :type="{ 'is-danger': errors.has('technician') }" :message="errors.first('technician')" horizontal
        :label="$translate('technician') | capitalize">
        <b-select v-model="patient.technician" v-validate="'required'" :placeholder="$translate('placeholder_tec')"
          :disabled="technicianIsDisabled" name="technician">
          <option v-for="user in availableUsersId" :key="user.name" :value="user.name">
            {{ user.name }}
          </option>
        </b-select>
      </b-field>
      <b-field :type="{ 'is-danger': errors.has('mercurio_id') }" :message="errors.first('mercurio_id')" horizontal
        :label="$translate('id_mercury') | capitalize">
        <b-input v-model="patient.mercurio_id" disabled name="mercurio_id" />
      </b-field>
      <b-field horizontal :label="$translate('name') | capitalize">
        <b-input v-model="patient.name" name="name" />
      </b-field>
      <b-field horizontal :label="$translate('surname') | capitalize">
        <b-input v-model="patient.surname" name="surname" />
      </b-field>
      <b-field horizontal :label="$translate('alias') | capitalize" :type="{ 'is-danger': errors.has('alias') }"
        :message="errors.first('alias')">
        <b-input v-model="patient.alias" v-validate="aliasRules" name="alias" />
      </b-field>
      <b-field horizontal :label="$translate('birth_date') | capitalize">
        <b-datepicker v-model="patient.birthdate" placeholder="Clicca per selezionare la data..." icon="calendar-today"
          locale="it-IT" :date-formatter="date => new Intl.DateTimeFormat('it-IT').format(date)" :date-parser="date => {
              let dateArray = date.split(/[.//-]/)
              return new Date(`${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`)
            }
            " editable />
      </b-field>
      <b-field horizontal :label="$translate('sex') | capitalize">
        <div class="block">
          <b-radio v-for="type in $availableSexType" :key="type" v-model="patient.gender" name="gender"
            :native-value="type | capitalize">
            {{ $translate(type) | capitalize }}
          </b-radio>
        </div>
      </b-field>
      <b-field horizontal :label="$translate('mail') | capitalize" :type="{ 'is-danger': errors.has('email') }"
        :message="errors.first('email')">
        <b-input v-model="patient.email" v-validate="'email'" name="email" />
      </b-field>
      <b-field horizontal :label="$translate('active') | capitalize">
        <b-switch v-model="patient.isActive" />
      </b-field>

      <b-field horizontal :label="$translate('note') | capitalize">
        <b-input v-model="patient.notes" maxlength="200" type="textarea" />
      </b-field>
      <p class="is-size-5">
        {{ $translate('address') | capitalize }}
      </p>
      <address-form :address.sync="patient.address" />
    </div>

    <b-modal :active.sync="isSavingModal" has-modal-card trap-focus aria-role="dialog" aria-modal :can-cancel="false">
      <div class="modal-card" style="width: auto; min-width: 200px">
        <section class="modal-card-body">
          <b-progress type="is-success" :value="progressvalue" />
        </section>
      </div>
    </b-modal>

    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false" />
  </section>
</template>

<script>
import addressForm from '@/components/AddressForm.vue'
import permissionMixin from '../../helpers/mixins/permissionMixin'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'
import firebase from 'firebase'

export default {
  $_veeValidate: {
    validator: 'new',
  },

  name: 'PatientForm',
  components: {
    'address-form': addressForm,
  },
  mixins: [permissionMixin, keyWordGenerator],
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    //var now = new Date();
    return {
      isLoading: false,
      isSavingModal: false,
      progressvalue: 0,
      availableShops: [],
      availableUsersId: [],
      availableCompanies: [],
      technicianIsDisabled: false,
      companyId: null,
      patient: {
        shopId: null,
        name: '',
        surname: '',
        alias: '',
        birthdate: null,
        technician: null,
        gender: 'Man',
        email: '',
        notes: '',
        address: {},
        isActive: true,
        mercurio_id: '',
      },
    }
  },
  computed: {
    aliasRules() {
      return this.patient.name == '' || this.patient.surname == '' ? 'required' : ''
    },
  },
  mounted() {
    if (
      !this.userInfo.type ||
      (this.userInfo.type == 'I' && (this.userInfo.level == '1' || this.userInfo.level == '2'))
    ) {
      this.$router.push('/forbidden')
    }
    if (this.userInfo.type == 'C' && this.userInfo.level != 'S') {
      this.availableUsersId.push({
        id: this.userInfo.id,
        name: this.userInfo.username,
      })
      this.patient.technician = this.userInfo.username
      this.technicianIsDisabled = true
    } else {
      //this.loadAvailableUsersId();
    }

    this.loadCompanies()

    //this.loadShops();
    // ! DEVO CONTROLLARE CHE ABBIA VISIBILITà SU QUEL PAZIENTE
    if (this.id) {
      this.loadDataToEdit()
    }
    // if (this.id) {
    //   //check sulla possibilità di editare tale paziente
    //   if (this.allCompanies) {
    //     this.loadDataToEdit();
    //   } else if (this.allShops) {
    //     this.availableShops.forEach(shop => {
    //       if (this.companiesId.contains(shop.companyId)) {
    //         this.loadDataToEdit();
    //       }
    //     });
    //   } else {
    //     this.availableShops.forEach(shop => {
    //       if (this.shopsId.contains(shop.id)) {
    //         this.loadDataToEdit();
    //       }
    //     });
    //   }
    // }
  },
  methods: {
    //dateParser(date) {
    //  let dateArray = date.split(/[.//-]/)
    //  return new Date(`${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`)
    //},
    deleteItem() {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('delete_confirm_text'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('delete'),
        onConfirm: async () => {
          await this.$db
            .collection('patients')
            .doc(this.id)
            .delete()
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_delete'),
          })
          this.$router.push({ name: 'patients' })
        },
      })
    },
    async send(exitbool) {
      if (await this.$validator.validateAll()) {
        this.patient.searchArray = this.generateKeyWord([
          this.patient.name, // + ' ' + this.patient.surname,
          this.patient.surname,
          this.patient.technician,
          this.patient.alias,
          this.patient.mercurio_id,
          this.availableShops.find(e => e.id == this.patient.shopId).name,
        ])
        this.id == 0 || this.id == null ? await this.newRequest(exitbool) : await this.updateRequest(exitbool)
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      }
    },
    async newRequest(exitbool) {
      this.isLoading = true
      this.patient.registeredAt = new Date().getTime()
      this.$db
        .collection('patients')
        .add(this.patient)
        .then(doc => {
          this.id = doc.id
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
          this.isLoading = false

          if (exitbool) {
            this.$router.push({ name: 'patients' })
          }
        })
        .catch(() => {
          //console.log(err);
          this.isLoading = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
    },
    async updateRequest(exitbool) {
      this.isLoading = true
      var batch = this.$db.batch()
      var updatepatient = this.$db.collection('patients').doc(this.id)
      let newsSearchArray = {}

      if (!this.patient.orders || this.patient.orders.length < 499) {
        for (let orders in this.patient.orders) {
          await this.$db
            .collection('orders')
            .doc(this.patient.orders[orders])
            .get()
            .then(doc => {
              if (doc.exists) {
                let order = doc.data()
                order.id = doc.id
                newsSearchArray[orders] = this.generateKeyWord([
                  this.patient.alias,
                  this.patient.name + ' ' + this.patient.surname,
                  order.primaryCode,
                  order.id_mercury,
                  order.company.name,
                ])
              } else {
                newsSearchArray[orders] = []
              }
            })
        }

        //TODO:500 limite
        for (let orders in this.patient.orders) {
          let updateorder = this.$db.collection('orders').doc(this.patient.orders[orders])
          if (newsSearchArray[orders].length != 0) {
            batch.update(updateorder, {
              patient: this.patient,
              searchArray: newsSearchArray[orders],
            })
          }
        }
        for (let orders in newsSearchArray) {
          if (newsSearchArray[orders].length == 0) {
            this.patient.orders.splice(orders, 1)
          }
        }
        batch.update(updatepatient, this.patient)
        batch
          .commit()
          .then(() => {
            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('success_form'),
              type: 'is-success',
            })
            this.isLoading = false

            if (exitbool) {
              this.$router.push({ name: 'patients' })
            }
          })
          .catch(() => {
            //console.log(err);
            this.isLoading = false

            this.$buefy.notification.open({
              duration: 3000,
              message: this.$translate('error_form_server'),
              type: 'is-danger',
            })
          })
      } else {
        this.isSavingModal = true
        this.progressvalue = 0
        for (let orders in this.patient.orders) {
          await this.$db
            .collection('orders')
            .doc(this.patient.orders[orders])
            .get()
            .then(doc => {
              if (doc.exists) {
                let order = doc.data()
                order.id = doc.id
                newsSearchArray[orders] = this.generateKeyWord([
                  this.patient.alias,
                  this.patient.name + ' ' + this.patient.surname,
                  order.primaryCode,
                  order.id_mercury,
                  order.company.name,
                ])
              } else {
                newsSearchArray[orders] = []
              }
            })
            .catch(() => { })
        }
        let counter = 0

        for (let orders in newsSearchArray) {
          if (newsSearchArray[orders].length == 0) {
            this.patient.orders.splice(orders, 1)
          }
        }

        for (let orders in this.patient.orders) {
          await this.$db
            .collection('orders')
            .doc(this.patient.orders[orders])
            .update({
              patient: this.patient,
              searchArray: newsSearchArray[this.patient.orders[orders]],
            })
            .then(() => {
              counter++
              this.progressvalue = (100 * counter) / this.patient.orders.length - 1
            })
            .catch(() => { })
        }
        await this.$db
          .collection('patients')
          .doc(this.id)
          .update(this.patient)
        this.progressvalue = 100
        this.isSavingModal = false
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('success_form'),
          type: 'is-success',
        })
      }
    },
    loadDataToEdit() {
      this.isLoading = true
      this.$db
        .collection('patients')
        .doc(this.id)
        .get()
        .then(doc => {
          let tec = doc.data().technician
          this.patient = doc.data()
          if (this.patient.birthdate) {
            this.patient.birthdate = this.patient.birthdate.toDate()
          }
          this.$db
            .collection('usersInfo')
            .where('username', '==', this.patient.technician)
            .get()
            .then(snapshot => {
              snapshot.forEach(user => {
                if (
                  this.availableUsersId.filter(el => {
                    return el.id === user.id
                  }).length == 0
                ) {
                  this.availableUsersId.push({
                    id: user.id,
                    name: user.data().username,
                  })
                }
              })
              this.patient.technician = tec
              this.isLoading = false
            })
          this.onCompanyChanged()
        })
    },
    loadShops() {
      if (this.allCompanies) {
        this.$db
          .collection('shops')
          .get()
          .then(docs => {
            docs.forEach(doc => {
              let shop = doc.data()
              shop.id = doc.id
              if (this.availableShops.find(el => el.id == shop.id) == undefined) {
                this.availableShops.push(shop)
              }
            })
          })
      } else if (this.allShops) {
        let promises = []
        this.companiesId.forEach(companyId => {
          promises.push(
            this.$db
              .collection('shops')
              .where('companyId', '==', companyId)
              .get()
          )
        })
        Promise.all(promises).then(snapshots => {
          snapshots.forEach(docs => {
            docs.forEach(doc => {
              let shop = doc.data()
              shop.id = doc.id
              if (this.availableShops.find(el => el.id == shop.id) == undefined) {
                this.availableShops.push(shop)
              }
            })
          })
        })
      } else {
        let promises = []
        this.shopsId.forEach(shopId => {
          promises.push(
            this.$db
              .collection('shops')
              .doc(shopId)
              .get()
          )
        })
        Promise.all(promises).then(snapshots => {
          snapshots.forEach(doc => {
            let shop = doc.data()
            shop.id = doc.id
            if (this.availableShops.find(el => el.id == shop.id) == undefined) {
              this.availableShops.push(shop)
            }
          })
        })
      }
    },
    loadAvailableUsersId() {
      if (this.allCompanies) {
        this.$db
          .collection('usersInfo')
          .where('type', '==', 'C')
          .get()
          .then(snapshot => {
            snapshot.forEach(user => {
              if (
                this.availableUsersId.filter(el => {
                  return el.id === user.id
                }).length == 0
              ) {
                this.availableUsersId.push({
                  id: user.id,
                  name: user.data().username,
                })
              }
            })
          })
      } else if (this.userInfo.type == 'I') {
        //Creo le promesse col where per ogni 10 compagnie
        let companyPromises = []
        let request = this.$db.collection('usersInfo').where('type', '==', 'C')
        for (let i = 0; i < this.companiesId.length; i += 10) {
          companyPromises.push(request.where('companyId', 'in', this.companiesId.slice(i, i + 10)).get())
        }
        //esaudisco tutte le promesse
        Promise.all(companyPromises).then(snapshots => {
          snapshots.forEach(snapshot => {
            //console.log(snapshot);
            snapshot.forEach(user => {
              //console.log(user);
              if (
                this.availableUsersId.filter(el => {
                  return el.id === user.id
                }).length == 0
              ) {
                this.availableUsersId.push({
                  id: user.id,
                  name: user.data().username,
                })
              }
            })
          })
        })
      } else {
        this.$db
          .collection('usersInfo')
          .where('type', '==', 'C')
          .where('companyId', '==', this.companiesId[0])
          .get()
          .then(snapshot => {
            snapshot.forEach(user => {
              if (
                this.availableUsersId.filter(el => {
                  return el.id === user.id
                }).length == 0
              ) {
                this.availableUsersId.push({
                  id: user.id,
                  name: user.data().username,
                })
              }
            })
          })
      }
    },
    loadCompanies() {
      if (this.allCompanies) {
        this.$db
          .collection('companies')
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              this.addCompanyToAvailableCompanies(doc)
            })
            this.selectDefaultCompany()
          })
      } else {
        let companyPromises = []
        let request = this.$db.collection('companies')
        for (let i = 0; i < this.companiesId.length; i += 10) {
          companyPromises.push(
            request.where(firebase.firestore.FieldPath.documentId(), 'in', this.companiesId.slice(i, i + 10)).get()
          )
        }
        Promise.all(companyPromises).then(snapshots => {
          snapshots.forEach(snapshot => {
            snapshot.forEach(doc => {
              this.addCompanyToAvailableCompanies(doc)
            })
          })
          this.selectDefaultCompany()
        })
      }
    },
    addCompanyToAvailableCompanies(doc) {
      let company = doc.data()
      company.id = doc.id
      this.availableCompanies.push(company)
    },
    selectDefaultCompany() {
      if (this.availableCompanies.length == 1) {
        this.patient.companyId = this.availableCompanies[0].id
        this.onCompanyChanged()
      }
    },
    onCompanyChanged() {
      const patientCompany = this.availableCompanies.find(c => c.id === this.patient.companyId)
      if (patientCompany) {
        this.patient.mercurio_id = patientCompany.mercurio_id
        this.loadShopsByCompanyId(patientCompany.id)
      }
      //this.availableCompanies.forEach((company) => {
      //if (company.id == this.patient.companyId || this.allCompanies) {
      //this.patient.mercurio_id = company.mercurio_id;
      //this.loadShopsByCompanyId(company.id);
      //}
      //});
    },
    onShopChanged() {
      this.availableShops.forEach(shop => {
        if (shop.id == this.patient.shopId) {
          this.loadTechniciansByShopId(this.patient.companyId, shop.id)
        }
      })
    },
    loadShopsByCompanyId(companyId) {
      this.availableShops = []
      this.$db
        .collection('shops')
        .where('companyId', '==', companyId)
        .get()
        .then(snapshot => {
          snapshot.forEach(doc => {
            let shop = doc.data()
            shop.id = doc.id
            if (this.allShops) {
              if (this.availableShops.find(el => el.id == shop.id) == undefined) {
                this.availableShops.push(shop)
              }
            } else {
              if (this.shopsId.find(el => el == shop.id) != undefined) {
                if (this.availableShops.find(el => el.id == shop.id) == undefined) {
                  this.availableShops.push(shop)
                }
              }
            }
          })
          this.onShopChanged()
        })
    },
    loadTechniciansByShopId(companyId, shopId) {
      if (!this.technicianIsDisabled) {
        this.availableUsersId = []

        this.$db
          .collection('usersInfo')
          .where('type', '==', 'C')
          .where('companyId', '==', companyId)
          .where('shopsId', 'array-contains-any', ['*', shopId])
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              if (
                this.availableUsersId.filter(el => {
                  return el.id === doc.id
                }).length == 0
              ) {
                let tec = doc.data()
                tec.id = doc.id
                tec.name = tec.username
                this.availableUsersId.push(tec)
              }
            })
          })
      }
    },
  },
}
</script>
